<template>
  <div class="my-item3 z-info">
    <template v-if="list && list.items.length">
      <div style="min-height: 400px;margin-bottom:20px;">
        <Row :gutter="30">
          <Col
            :sm="12"
            :md="6"
            class="w-20"
          >
            <div class="addPro" @click="$router.push('/exhibitionEn/index/product/addpro?id=' + query.id)">
              <div></div>
              <i class="icon iconfont icon-jia3"></i>
              <span>Add products</span>
            </div>
          </Col>
          <Col
            :sm="12"
            :md="6"
            v-for="(item, index) in list.items"
            :key="'ProductInt-' + index"
            class="w-20"
          >
            <div class="pro">
              <div class="pro-top">
                <div v-if="!item.isShow" class="product-show">
                  <i class="icon iconfont icon-hide"></i>
                </div>
                <img :src="item.banner[0]" v-if="item.banner && item.banner[0]" />
                <img src="@/assets/img/empty.png" v-else />
              </div>
              <div class="pro-title">
                <p
                  class="info"
                  :title="item.name"
                  :class="setProStatus(item.applyStart, item.applyEnd)"
                >{{item.name}}</p>
                <div class="time" v-if="item.isApply && false">
                  剩余：
                  {{item.applyEnd | time_sort}}
                </div>
              </div>

              <div class="pro-tool">
                <div class="pro-tool-item" @click="showEdit(item)" style="color:#1890ff;">Edit</div>
                <div class="pro-tool-line">|</div>
                <template v-if="item.isShow">
                  <div class="pro-tool-item" @click="showOff(item)">Hide</div>
                </template>
                <template v-else>
                  <div class="pro-tool-item" @click="showOn(item)">display</div>
                </template>
                <div class="pro-tool-line">|</div>
                <div class="pro-tool-item">
                  <Poptip
                    width="160"
                    confirm
                    placement="top-start"
                    title="确认删除此产品吗 ?"
                    ok-text="confirm"
                    cancel-text="cancel"
                    @on-ok="delItem(item, index)"
                    @on-cancel="handleClose(index)"
                    popper-class="del-popper"
                  >Delete</Poptip>
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <div
          class="my-page"
          v-if="totalCount > pageSize"
          style="text-align:center;padding-top: 20px"
        >
          <Page
            show-total
            show-elevator
            :page-size="pageSize"
            :current="pageIndex"
            :total="totalCount"
            @on-change="changePage"
            @on-page-size-change="changePageSize"
          />
        </div>
      </div>
    </template>
    <emptyList v-else @change="Add()"></emptyList>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import emptyList from "@components/En/emptyList/emptyList";

export default {
  name: "exhibition-product-item",
  data() {
    return {
      list: null,

      pageSize: 20,
      pageIndex: 1,
      totalCount: 0
    };
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany"
    }),
    query() {
      return this.$router.history.current.query;
    },
    option() {
      return {
        By: this.query.id,
        PageSize: this.pageSize,
        PageIndex: this.pageIndex,
      };
    }
  },
  components: {
    emptyList
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
      getProductByGroupId: "productModule/getProductByGroupId",
      delProduct: "productModule/delProduct",
      setProductShow: "productModule/setProductShow",
    }),
    async init() {
      let proData = await this.getProductByGroupId(this.option);
      if (proData) {
        proData.items.map(c => {
          if (c.banner) {
            c.banner = JSON.parse(c.banner);
          } else {
            c.banner = [];
          }
          c.visible = false;
        });
        this.list = proData;
        this.pageSize = proData.pageSize;
        this.pageIndex = proData.pageIndex;
        this.totalCount = proData.totalCount; 
      }
      console.log("proData：",proData);
    },
    // 修改产品显示、屏蔽
    async showOff(item) {
      let result = await this.setProductShow({ Id: item.id, IsShow: false });
      if (result.successed) {
        this.$Message.success("修改成功");
        this.init();
      } else {
        this.$Message.error("修改失败，请重新尝试");
      }
    },
    async showOn(item) {
      let result = await this.setProductShow({ Id: item.id, IsShow: true });
      if (result.successed) {
        this.$Message.success("修改成功");
        this.init();
      } else {
        this.$Message.error("修改失败，请重新尝试");
      }
    },
    del(item) {
      this.$Modal.confirm({
        content: `确认删除 ${item.name} 此产品吗 `,
        onOk: () => {
          this.delItem(item);
        },
        onCancel: () => {
        }
      });
    },
    async delItem(item) {
      let result = await this.delProduct(item.id);
      if (result.successed) {
        this.$Message.success("删除成功");
        this.init();
      } else {
        this.$Message.error("删除失败，请重新尝试");
      }
    },
    Add() {
      this.$router.push("/exhibitionEn/index/product/addpro");
    },
    showEdit(item) {
      this.$router.push(`/exhibitionEn/index/product/editpro?id=${item.id}`);
    },
    changePage(e) {
      this.pageIndex = e;
      this.init();
      
    },
    changePageSize(e) {
      this.pageSize = e;
      this.init();
      
    },
    setProStatus(start, end) {
      let status = {
        end: false,
        ing: false,
        start: false
      };
      if (!start || !end) return status;
      let startNum = new Date(start).getTime();
      let endNum = new Date(end).getTime();
      let now = new Date().getTime();
      if (endNum < now) status.end = true;
      if (endNum > now && startNum < now) status.ing = true;
      if (startNum > now) status.start = true;
      return status;
    },

    handleOpen(index) {
      this.list.items[index].visible = true;
    },
    handleClose(index) {
      this.list.items[index].visible = false;
    },
    toggleOpen(index) {
      let visible = this.list.items[index].visible;
      this.list.items[index].visible = !visible;
    }
  } 
};
</script>

<style lang="scss">
.my-item3 {
  min-width: 600px;
  padding: 30px 30px 50px 30px;

  &-box {
    background-color: #fff;
    margin-bottom: 30px;
  }

  .addPro {
    background-color: #fff;
    width: 100%;
    padding-bottom: 66.666667%;
    position: relative;
    cursor: pointer;
    div {
      width: 100%;
      height: 90px;
    }
    .icon{
      font-size: 60px;
      width: 100%;
      text-align: center;
      display: block;
      color:#999;
      position: absolute;
      bottom: 45%;
    }
    span{
      display: block;
      width: 100%;
      font-size: 18px;
      color:#999;
      text-align: center;
      position: absolute;
      bottom: 30%;
      text-align: center;
    }
  }
  .pro {
    margin-bottom: 20px;
    position: relative;
    &-top {
      width: 100%;
      padding-bottom: 66.666667%;
      position: relative;
      background-color: #f8f9fb;
      img {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        max-width: 100%;
        max-height: 100%;
      }
    }

    &-title {
      background: #fff;
      // height: 33px;
      padding: 10px 10px 8px 12px;
      .info,
      .time {
        font-size: 16px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #1a1a1a;
        text-align: center;
        &.end {
          color: #f00;
        }
        &.ing {
          color: green;
        }
        &.start {
          color: #fe791e;
        }
      }
      .time {
        color: #fe791e;
      }
    }

    &-tool {
      display: flex;
      align-items: center;
      justify-content: space-around;
      background-color: #f8f9fb;

      &-item {
        flex: 1;
        line-height: 48px;
        font-size: 14px;
        color: #808080;
        cursor: pointer;
        text-align: center;

        &.z-del {
          color: #f00;
        }

        &.z-primary {
          color: #1890ff;
        }
      }

      &-line {
        color: #e8e8e8;
        font-size: 20px;
      }
    }
  }

  .my-page {
    padding-bottom: 50px;
  }
  .product-show {
    position: absolute;
    z-index: 1;
    right: 0;
    width: 0;
    height: 0;
    border-width: 20px;
    border-style: solid;
    border-color: #ccc #ccc transparent transparent;
    i {
      position: absolute;
      top: -25px;
      right: -20px;
      color: #fff;
      font-size: 25px;
    }
  }
}
.del-popper {
  .ivu-poptip-confirm, .ivu-poptip-footer {
    padding: 8px 14px 16px;
  }
}
</style> 
